module.exports = __webpack_public_path__ + "static/media/14.7e918bd1.webp";